import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	server: {
		SERVER_URL: z.string().url().optional(),
	},

	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: "VITE_",

	client: {
		VITE_APP_NAME: z.string().min(1),
		VITE_APP_ENVIRONMENT: z.enum(["local", "stage", "prod"]),
		VITE_APP_VERSION: z.string().min(1),
		VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
		VITE_BACKEND_API_URL: z.string().url().min(1),
	},

	/**
	 * What object holds the environment variables at runtime. This is usually
	 * `process.env` or `import.meta.env`.
	 */
	runtimeEnv: import.meta.env,

	emptyStringAsUndefined: true,
});
